import { createTrackerOptions } from '@/helpers/common';

export const TRIP_MAX_YEAR = 5;
export const TRIP_MONTH_MAX = 18;
export const MAX_CHILDREN_NUMBER = 8;
export const MAX_TRAVELLERS_IN_GROUP = 10;
export const OPTIONAL_EXTRA_COVER_MAX = 1000000;
export const SLIDER_MAX_VALUE = 500;
export const INSURER_MIN_AGE = 18;

export const OPTIONAL_EXTRAS_OPTIONS = [
  {
    value: 'maxExcess',
    label: 'Max excess per feature',
  },
  {
    value: 'medical',
    label: 'Medical cover',
  },
  {
    value: 'cancellation',
    label: 'Cancellation cover',
  },
  {
    value: 'baggage',
    label: 'Baggage cover',
  },
];

export const ADDITIONAL_COVER_OPTIONS = [
  {
    value: 'gadget',
    trackerValue: 'gadgetCover',
    label: 'Gadget cover',
  },
  {
    value: 'winterSports',
    trackerValue: 'winterSportsCover',
    label: 'Winter Sports cover',
  },
  {
    value: 'cruise',
    trackerValue: 'cruiseCover',
    label: 'Cruise cover',
  },
];

export const OPTIONAL_EXTRAS_TRACKER_OPTIONS = createTrackerOptions(ADDITIONAL_COVER_OPTIONS);
